<template>
  <rh-etapa-card
    titulo="Formação Acadêmica"
    subtitulo="Escolaridade e cursos concluídos"
    icone="mdi-school"
  >
    <template #acoes>
      <v-btn
        color="primary"
        outlined
        small
        class="rounded-lg"
        :disabled="removendo || !podeAdicionarMaisFormacoes"
        @click="form.formacoes.push(novaFormacao())"
      >
        <v-icon left>mdi-plus</v-icon> Adicionar Formação
      </v-btn>
    </template>

    <v-row class="mb-4">
      <v-col cols="12" class="pt-0 pb-0">
        <e-label>Maior Nível de Escolaridade Concluído</e-label>
        <v-autocomplete
          :items="$constants.nivelEscolaridadeConcluidoList"
          :return-object="false"
          v-model="form.pessoal.nivel_escolaridade_concluido"
          label="Selecione uma opção"
          dense
          solo
        />
      </v-col>
    </v-row>

    <div
      v-if="!form.formacoes || form.formacoes.length === 0"
      class="text-center py-6 grey--text font-italic"
    >
      Nenhuma formação acadêmica cadastrada. Clique no botão acima para adicionar.
    </div>

    <v-card
      v-for="(formacao, index) in form.formacoes"
      :key="'formacao-' + index"
      class="rh-subcard mb-4 pa-4"
      outlined
      rounded="lg"
    >
      <div class="d-flex justify-space-between align-center mb-3">
        <span class="text-subtitle-2 font-weight-bold primary--text">Curso #{{ index + 1 }}</span>
        <v-btn
          color="error"
          text
          small
          :disabled="removendo"
          @click="removerRelacaoFormacao(index)"
        >
          <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-delete-outline</v-icon>
          <span class="d-none d-sm-inline">Remover Formação</span>
        </v-btn>
      </div>

      <v-row>
        <v-col cols="12" md="6" class="pt-0 pb-0">
          <e-label>Área do curso</e-label>
          <v-autocomplete
            :items="$constants.areaDoCursoList"
            :return-object="false"
            v-model="formacao.area_do_curso"
            label="Selecione uma opção"
            dense
            solo
          />
        </v-col>

        <v-col cols="12" md="6" class="pt-0 pb-0">
          <e-label>Curso</e-label>
          <v-text-field v-model="formacao.curso" dense solo />
        </v-col>
      </v-row>
    </v-card>

    <rh-documentos-secao
      categoria="formacao"
      titulo="Diplomas e certificados"
      subtitulo="Ex.: diploma, histórico escolar, certificados de cursos."
      :itens="documentos"
      v-on="$listeners"
    />
  </rh-etapa-card>
</template>

<script>
import RhEtapaCard from "../components/RhEtapaCard.vue";
import RhDocumentosSecao from "../components/RhDocumentosSecao.vue";
import { novaFormacao } from "../config/rhConfig";

export default {
  name: "EtapaFormacaoAcademica",
  components: { RhEtapaCard, RhDocumentosSecao },
  props: {
    form: { type: Object, required: true },
    documentos: { type: Array, default: () => [] },
  },
  data() {
    return {
      removendo: false,
    };
  },
  computed: {
    podeAdicionarMaisFormacoes() {
      const lista = this.form.formacoes;
      if (!Array.isArray(lista) || lista.length === 0) {
        return true;
      }
      const ultima = lista[lista.length - 1];
      return Boolean(ultima.area_do_curso && ultima.curso);
    },
  },
  methods: {
    novaFormacao,
    async removerRelacaoFormacao(index) {
      const formacao = this.form.formacoes[index];

      if (this.form.formacoes.length < 2) {
        this.$toast.danger("É necessário cadastrar pelo menos uma formação");
        return;
      }

      if (formacao.id) {
        try {
          this.removendo = true;
          await this.$services.recursosHumanosService.removerFormacao(formacao.id);
          this.$toast.success("Formação removida com sucesso");
        } catch (error) {
          this.$handleError(error);
          return;
        } finally {
          this.removendo = false;
        }
      }

      this.form.formacoes.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.rh-subcard {
  background-color: var(--surface-2) !important;
  border: 1px dashed var(--border) !important;
}
</style>
